/** Select In Progress without losing custom tags or refreshing its timestamp. */
export function inProgressTags(definitions, tags = []) {
  const progress = definitions.find(tag => tag.mandatory && tag.name === 'In Progress');
  if (!progress) return tags || [];
  const idOf = tag => typeof tag === 'string' ? tag : tag.tagId;
  const statusIds = new Set(definitions.filter(tag => tag.mandatory).map(tag => tag.id));
  const kept = (tags || []).filter(tag => !statusIds.has(idOf(tag)) || idOf(tag) === progress.id);
  if (!kept.some(tag => idOf(tag) === progress.id)) kept.push({tagId: progress.id, setAt: new Date().toISOString()});
  return kept;
}

/** Toggle a draft selection, keeping status tags mutually exclusive. */
export function toggleTagSelection(ids, tagId, definitions) {
  if (ids.includes(tagId)) return ids.filter(id => id !== tagId);
  const exclusive = definitions.find(tag => tag.id === tagId)?.mandatory;
  const statusIds = new Set(definitions.filter(tag => tag.mandatory).map(tag => tag.id));
  return [...ids.filter(id => !exclusive || !statusIds.has(id)), tagId];
}

/** Explicit status tags take precedence over legacy status retained by old imports. */
export function statusFromTags(node, definitions) {
  const ids = new Set((node?.tags || []).map(tag => typeof tag === 'string' ? tag : tag.tagId));
  const selected = new Set(definitions.filter(tag => tag.mandatory && ids.has(tag.id)).map(tag => tag.name));
  if (selected.has('Done')) return 'done';
  if (selected.has('In Progress')) return 'in-progress';
  if (selected.has('Todo')) return 'todo';
  return node?.status || 'todo';
}
